import { RouterProvider } from "@tanstack/react-router";
import type { FC } from "react";
import { StrictMode } from "react";

import { router } from "@/router";

/** ------------------------------------------------------------------
 *  App (MAIN)
 *  ------------------------------------------------------------------ */
/**
 * The main application component.
 * Uses TanStack Router for navigation with file-based routing.
 *
 * Note: TanStack Devtools are now integrated in __root.tsx
 * for better lazy-loading and plugin architecture.
 */
const App: FC = () => {
  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
};

// Handle URL hash navigation when page loads
if (typeof window !== "undefined") {
  window.addEventListener("DOMContentLoaded", () => {
    // If the URL has a hash, scroll to it
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView();
      }
    }
  });
}

export default App;
